<template>
    <div class="sign_form_box">
        <el-form :rules="rules" ref="form" :model="form" label-width="140px">
            <el-form-item prop="signTypeValue" label="入驻类型">
                <el-select
                    v-model="form.signTypeValue"
                    placeholder="请选择入驻类型"
                >
                    <el-option
                        v-for="item in signTypeData"
                        :key="item.signTypeValue"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="name" label="电台名称">
                <el-input
                    v-model="form.name"
                    placeholder="最多20个字符"
                    maxlength="20"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item prop="desc" label="简介">
                <el-input
                    type="textarea"
                    v-model="form.desc"
                    resize="none"
                    placeholder="最多200个字符"
                    :rows="4"
                    maxlength="200"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item label="所在地" required>
                <div class="region_box">
                    <el-select v-model="form.province" placeholder="省">
                        <el-option
                            v-for="(item, i) in locationMainland"
                            :key="i"
                            :label="item.province"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    &emsp;
                    <el-select v-if="cityData && cityData.length" v-model="form.city" placeholder="市">
                        <el-option
                            v-for="(item, i) in cityData"
                            :key="i"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    &emsp;
                    <el-select v-if="areaData && areaData.length" v-model="form.area" placeholder="县/区">
                        <el-option
                            v-for="(item, i) in areaData"
                            :key="i"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="电台头像" required>
                <div class="form_uppic_box">
                    <CropImageAndUpload v-model="form.avatarImg" />
                    <p class="placeholder">
                        图片尺寸建议400x400px，<br />仅支持png、jpg格式
                    </p>
                </div>
            </el-form-item>
            <el-form-item
                v-if="form.signTypeValue == 1"
                label="统一社会信用编码"
                prop="socialCreditCode"
            >
                <el-input
                    v-model="form.socialCreditCode"
                    placeholder="18位编码"
                    maxlength="18"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item
                v-if="form.signTypeValue == 1"
                label="营业执照上传"
                required
            >
                <div class="form_uppic_box">
                    <UploadImage
                        class="form_upload_pic uploader_size"
                        v-model="form.businessLicenseImg"
                    />
                    <p class="placeholder">
                        照片信息必须清晰可见， 大小不超过5M，<br />
                        仅支持png、jpg格式
                    </p>
                </div>
            </el-form-item>
            <el-form-item
                prop="personalName"
                v-if="form.signTypeValue == 2"
                label="入驻人姓名"

            >
                <el-input
                    v-model="form.personalName"
                    placeholder="请输入姓名"
                ></el-input>
            </el-form-item>
            <el-form-item
                prop="personalPhone"
                v-if="form.signTypeValue == 2"
                label="入驻人联系电话"
            >
                <el-input
                    type="tel"
                    v-model="form.personalPhone"
                    placeholder="请输入联系电话"
                    maxlength="11"
                ></el-input>
            </el-form-item>
            <el-form-item
                v-if="form.signTypeValue == 2"
                prop="personalCode"
                label="入驻人身份证号码"

            >
                <el-input
                    maxlength="18"
                    v-model="form.personalCode"
                    placeholder="正确的身份证号码"
                ></el-input>
            </el-form-item>
            <el-form-item
                v-if="form.signTypeValue == 2"
                label="手持身份证正面照"
                required
            >
                <div class="form_uppic_box">
                    <UploadImage
                        v-model="form.identityPic"
                        class="form_upload_pic"
                    />
                    <p class="placeholder">
                        照片信息必须清晰可见， 大小不超过5M，<br />
                        仅支持png、jpg格式
                    </p>
                </div>
            </el-form-item>
            <el-form-item prop="ajmideAccount" label="阿基米德账号" >
                <el-input
                    v-model="form.ajmideAccount"
                    placeholder="请输入您的阿基米德APP用户名"
                    maxlength="20"
                ></el-input>
            </el-form-item>
            <el-form-item label="（选填）其他附件">
                <el-upload
                    class="uploader_file"
                    accept="image/png, image/jpeg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    action="//a.ajmide.com/business/file_upload.php"
                    :multiple="false"
                    :limit="5"
                    :on-success="onFileSuccess"
                    :on-remove="onFileDelete"
                    :on-exceed="onFull"
                    show-file-list
                >
                    <div class="file_upload_box">
                        <el-button
                            slot="trigger"
                            size="small" type="primary"
                            >点击上传</el-button
                        >
                        <div class="placeholder">
                            仅支持png/jpg/WORD/PDF格式上传，<br />最多支持上传5个文件
                        </div>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item                
                prop="worksLink"
                label="（选填）作品链接"
            >
                <el-input
                    v-model="form.worksLink"
                    placeholder="输入作品链接地址"
                ></el-input>
            </el-form-item>
            <el-form-item                
                prop="worksNum"
                label="（选填）作品集数"
            >
                <el-input
                    v-model="form.worksNum"
                    placeholder="输入数字"
                    @keyup.native="checkNumber($event)"
                ></el-input> 集
            </el-form-item>
            <el-form-item label="">
                <div class="addopra_btnbox">
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="addOperatorForm"
                        >添加运营者信息</el-button
                    >
                    <p class="placeholder">
                        必填1个运营者信息，<br />最多可添加5个管理员
                    </p>
                </div>

                <el-form
                    class="operator_box"
                    label-position="left"
                    label-width="140px"
                    v-for="(operatorItem, key) in form.operators"
                    :key="key"
                >
                    <el-form-item label="运营者姓名" required>
                        <el-input
                            v-model="form.operators[key].name"
                            placeholder="请输入姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="运营者手机" required>
                        <el-input
                            maxlength="11"
                            v-model="form.operators[key].phone"
                            placeholder="请输入联系电话"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="运营者身份证号" required>
                        <el-input
                            v-model="form.operators[key].identityCode"
                            placeholder="请输入正确的证件号码"
                            maxlength="18"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手持身份证正面照" required>
                        <div class="form_uppic_box">
                            <UploadImage
                                v-model="form.operators[key].identityPic"
                                class="form_upload_pic"
                            />
                            <p class="placeholder">
                                照片信息必须清晰可见，
                                <br />大小不超过5M，<br />
                                仅支持png、jpg格式
                            </p>
                        </div>
                    </el-form-item>
                    <div
                        v-if="form.operators.length > 1"
                        class="del_opra"
                        @click="delOperator(key)"
                    >
                        <el-link :underline="false">删除</el-link>
                    </div>
                </el-form>
            </el-form-item>
            <div class="agreement_box">
                <div class="ck_btn_box" @click="clickReadAgreementCheckbox($event)">
                <el-checkbox :disabled="!readAgreement" v-model="form.agreement"></el-checkbox></div>&emsp;
                我已阅读并同意<el-link
                    @click="showAgreement"
                    type="primary"
                    :underline="false"
                    >《阿基米德号平台服务协议》</el-link
                >
            </div>
            <div class="submit_box">
                <el-button @click="showVerifyModal" type="warning"
                    >提交申请</el-button
                >
            </div>
        </el-form>

        <el-dialog
            class="verify_modal_form"
            center
            title="申请提交验证"
            :visible.sync="dialogFormVisible"
        >
            <el-form>
                <el-form-item label-width="0">
                    <div class="relative">
                        <el-input
                            maxlength="11"
                            v-model="form.verifyPhone"
                            autocomplete="off"
                            placeHolder="输入您的手机号码"
                        ></el-input>
                        <div class="get_code">
                            <p class="timming" v-if="smsTimming > 0">
                                {{ smsTimming }}秒后重试
                            </p>
                            <el-link
                                v-else
                                type="warning"
                                @click="clickGetVerfyCode"
                                :underline="false"
                                >获取验证码</el-link
                            >
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label-width="0">
                    <el-input
                        v-model="form.verifyCode"
                        autocomplete="off"
                        placeHolder="输入验证码"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="warning" @click="submit_form"
                    >确认提交</el-button
                >
                <el-link
                    type="info"
                    @click="
                        () => {
                            this.dialogFormVisible = false;
                        }
                    "
                    :underline="false"
                    >放弃</el-link
                >
            </div>
        </el-dialog>
        <el-dialog
            class="sign_result_modal"
            center
            title="入驻申请提交成功"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="signResultDialogVisible"
            @close="backToPrev"
        >
            <div class="sign_result_modal_body">
                <p>您的审批号为</p>
                <p class="sign_application_code">{{ this.applicationCode }}</p>
                <el-alert
                    title="审核结果将在7个工作日内以短信方式通知您"
                    type="warning"
                    center
                    :closable="false"
                >
                </el-alert>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="warning" @click="backToPrev">返回</el-button>
            </div>
        </el-dialog>

        <ModalAgreement
            :agreementDialogVisible="agreementDialogVisible"
            :readAgreement="readAgreement"
            :contractText="contractText"
            @agree="agreeBtnClick"
            @closed="closeAgreementModal"
        />
    </div>
</template>
<style>
.el-dialog__footer {
    text-align: center;
}
.rich-text {
    height: 500px;
}
</style>
<script>
import CropImageAndUpload from '../common/components/CropImageAndUpload';
import UploadImage from '../common/components/UploadImage';
import locationMainland from '../common/location_mainland.json';
import ModalAgreement from '../common/components/ModalAgreement';
import { getVerifyCode, signIn, getRunningOnlineContract } from '../Api';
import { checkPersonalIndentityCode, checkMobile, checkNum } from '../common/regs';
export default {
    name: 'SignIn',
    components: { CropImageAndUpload, UploadImage, ModalAgreement },
    data() {
        return {
            smsTimming: 0,
            extFilesFull: false,
            readAgreement: false,
            submitReqBody: null,
            applicationCode: '',
            rules: {
                signTypeValue: [
                    {
                        required: true,
                        message: '请选择入驻类型',
                        trigger: 'change',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: '请输入电台名称',
                        trigger: 'blur',
                    },
                    { max: 20, message: '最多20个字符', trigger: 'blur' },
                ],
                desc: [
                    {
                        required: true,
                        message: '请输入简介',
                        trigger: 'blur',
                    },
                    { max: 200, message: '最多200个字符', trigger: 'blur' },
                ],
                socialCreditCode: [
                    {
                        required: true,
                        message: '请输入正确的统一社会信用编码',
                        trigger: 'blur',
                    },
                    {
                        max: 18,
                        message: '请输入正确的统一社会信用编码',
                        trigger: 'blur',
                    },
                ],
                personalName: [
                    {
                        required: true,
                        message: '请输入入驻人姓名',
                        trigger: 'blur',
                    },
                ],
                personalPhone: [
                    {
                        required: true,
                        message: '请输入入驻人联系电话',
                        trigger: 'blur',
                    },
                    {
                        min: 11,
                        max: 11,
                        message: '请输入正确的电话号码',
                        trigger: 'blur',
                    },
                ],
                personalCode: [
                    {
                        required: true,
                        message: '请输入入驻人身份证号码',
                        trigger: 'blur',
                    },
                ],
                ajmideAccount: [
                    {
                        required: true,
                        message: '请输入阿基米德账号',
                        trigger: 'blur',
                    },
                ],
                worksLink: [
                    {
                        required: false,
                        message: '请输入作品链接',
                        trigger: 'blur',
                    },
                ],
                worksNum: [
                    {
                        required: false,
                        message: '请输入作品集数',
                        trigger: 'blur',
                    },
                ]
            },
            agreementDialogVisible: false,
            dialogFormVisible: false,
            signResultDialogVisible: false,
            locationMainland,
            cityData: null,
            areaData: null,
            signTypeData: [
                {
                    value: 1,
                    label: '机构',
                },
                {
                    value: 2,
                    label: '个人',
                },
            ],
            form: {
                name: '',
                signTypeValue: '',
                desc: '',
                socialCreditCode: '',
                province: null,
                city: null,
                area: null,
                avatarImg: '',
                businessLicenseImg: '',
                personalName: '',
                personalPhone: '',
                personalCode: '',
                identityPic: '',
                ajmideAccount: '',
                extFiles: [],
                operators: [{}],
                agreement: false,
                worksLink:'',
                worksNum:''
            },
            contractText: ''
        };
    },
    watch: {
        'form.province': function(provinceId) {
            console.log('watch', provinceId);
            this.areaData = [];
            this.form.city = null;
            this.form.area = null;
            this.locationMainland.some((provinceItem) => {
                if (provinceItem.id == provinceId) {
                    if (provinceItem.city) {
                        this.cityData = provinceItem.city;
                    }
                    return true;
                }
            });
        },
        'form.city': function(cityId) {
            console.log('city', cityId);
            this.form.area = null;
            this.cityData.some((cityItem) => {
                if (cityItem.id == cityId) {
                    if (cityItem.area) {
                        this.areaData = cityItem.area;
                    }
                    return true;
                }
            });
        },
    },
    methods: {
        onFull: function() {
            this.$alert('最多只能上传5个附件');
        },
        onFileSuccess: function(response, file, fileList) {
            const fileArr = [];
            fileList.forEach((fileEle) => {
                if (fileEle.status == 'success' && fileEle.response) {
                    fileArr.push(fileEle.response.data.filename);
                }
            });
            this.form.extFiles = fileArr;
            this.extFilesFull = this.form.extFiles.length >= 5;
            console.log('onFileSuccess this.form.extFiles', this.form.extFiles, fileList);
        },

        onFileDelete: function(file, fileList) {
            console.log('onFileDelete', file, fileList);
            const fileArr = [];
            fileList.forEach((fileEle) => {
                if (fileEle.status == 'success' && fileEle.response) {
                    fileArr.push(fileEle.response.data.filename);
                }
            });
            this.form.extFiles = fileArr;
            this.extFilesFull = this.form.extFiles.length >= 5;
        },

        addOperatorForm: function() {
            if (this.form.operators.length < 5) {
                this.form.operators.push({});
            }
        },
        delOperator: function(key) {
            if (this.form.operators.length >= 2) {
                this.form.operators.splice(key, 1);
            }
        },
        showAgreement: function() {
            getRunningOnlineContract().then((res) => {
                this.contractText = res.data.contract_text.replace(/\n/g, '<br>')
                this.agreementDialogVisible = true;
            })
        },

        agreeBtnClick: function(res) {
            this.readAgreement = res.read;
            this.form.agreement = res.agree;
            this.agreementDialogVisible = false;
        },

        closeAgreementModal: function() {
            this.agreementDialogVisible = false;
        },

        clickGetVerfyCode: function() {
            const _this = this;
            if (_this.smsTimming <= 0 && this.form.verifyPhone) {
                getVerifyCode(this.form.verifyPhone).then((res) => {
                    if (res.code == 0) {
                        _this.smsTimming = 60;
                        _this.timmer = setInterval(() => {
                            _this.smsTimming--;
                            if (_this.smsTimming < 1 && _this.timmer) {
                                clearInterval(_this.timmer);
                            }
                        }, 1000);
                    } else if (res.message){
                        _this.$alert(res.message);
                    }
                });
            }
        },

        clickReadAgreementCheckbox: function() {
            if (!this.readAgreement) {
                this.$alert('请阅读《阿基米德号平台服务协议》');
            }
        },

        showVerifyModal: function() {
            const submitReqBody = {};

            let arrMsg = '';
            if (!this.form.signTypeValue) {
                arrMsg = '请选择入驻类型';
            } else {
                submitReqBody.joiner_type = this.form.signTypeValue;
            }

            if (!this.form.name && !arrMsg) {
                arrMsg = '请填写电台名称';
            } else if (this.form.name) {
                submitReqBody.radio_name = this.form.name;
            }

            if (!this.form.desc && !arrMsg) {
                arrMsg = '请填写电台简介';
            } else if (this.form.desc) {
                submitReqBody.radio_intro = this.form.desc;
            }

            if (
                (!this.form.province || !this.form.city) &&
                !arrMsg
            ) {
                arrMsg = '请选择所在地';
            } else if (this.form.province && this.form.city) {
                submitReqBody.provinceId = this.form.province;
                submitReqBody.cityId = this.form.city;
                submitReqBody.areaId = this.form.area;
            }

            if (!this.form.avatarImg && !arrMsg) {
                arrMsg = '请上传电台头像';
            } else if (this.form.avatarImg && this.form.avatarImg.filename) {
                submitReqBody.radio_logo = this.form.avatarImg.filename;
            }

            if (this.form.signTypeValue == 1) {
                if (!this.form.socialCreditCode && !arrMsg) {
                    arrMsg = '请填写统一社会信用编码';
                } else if (this.form.socialCreditCode) {
                    submitReqBody.credit_code = this.form.socialCreditCode;
                }
                if (!this.form.businessLicenseImg && !arrMsg) {
                    arrMsg = '请上传营业执照';
                } else if (this.form.businessLicenseImg) {
                    submitReqBody.business_certificate = this.form.businessLicenseImg.filename;
                }
            }

            if (this.form.signTypeValue == 2) {
                if (!this.form.personalName && !arrMsg) {
                    arrMsg = '请填写入驻人姓名';
                } else if (this.form.personalName) {
                    submitReqBody.joiner_realname = this.form.personalName;
                }
                if ((!this.form.personalPhone || !checkMobile(this.form.personalPhone)) && !arrMsg) {
                    arrMsg = '请填写正确的入驻人联系电话';
                } else if (this.form.personalPhone) {
                    submitReqBody.joiner_phone = this.form.personalPhone;
                }
                if ((!this.form.personalCode || !checkPersonalIndentityCode(this.form.personalCode)) && !arrMsg) {
                    arrMsg = '请填写正确的入驻人身份证号码';
                } else if (this.form.personalCode) {
                    submitReqBody.joiner_identity_code = this.form.personalCode;
                }
                if (!this.form.identityPic && !arrMsg) {
                    arrMsg = '请上传入驻人身份证照片';
                } else if (this.form.identityPic && this.form.identityPic.filename) {
                    submitReqBody.joiner_identity = this.form.identityPic.filename;
                }
            }

            if (!this.form.ajmideAccount && !arrMsg) {
                arrMsg = '请填写阿基米德账号';
            } else if (this.form.ajmideAccount) {
                submitReqBody.aj_username = this.form.ajmideAccount;
            }

            submitReqBody.managers_info = [];
            this.form.operators.forEach((ele) => {
                const _reqOpra = {};
                if (!arrMsg && !ele.name) {
                    arrMsg = '请填写运营者姓名';
                } else if (ele.name) {
                    _reqOpra.manager_realname = ele.name;
                }
                if (!arrMsg && (!ele.phone || !checkMobile(ele.phone))) {
                    arrMsg = '请填写正确的运营者联系电话';
                } else if (ele.phone) {
                    _reqOpra.manager_phone = ele.phone;
                }
                if (!arrMsg && (!ele.identityCode || !checkPersonalIndentityCode(ele.identityCode))) {
                    arrMsg = '请填写正确的运营者身份证号码';
                } else if (ele.identityCode) {
                    _reqOpra.joiner_identity_code = ele.identityCode;
                }
                if (!arrMsg && !ele.identityPic) {
                    arrMsg = '请上传运营者身份照片';
                } else if (ele.identityPic && ele.identityPic.filename) {
                    _reqOpra.joiner_identity = ele.identityPic.filename;
                }
                submitReqBody.managers_info.push(_reqOpra);
            });

            if (!arrMsg && !this.form.agreement) {
                arrMsg = '请阅读并同意《阿基米德号平台服务协议》';
            } else {
                submitReqBody.confirm_agreement = this.form.agreement ? 1 : 0;
            }

            submitReqBody.enclosure_files = this.form.extFiles;
            submitReqBody.worksLink = this.form.worksLink;
            
            if (this.form.worksNum && parseInt(this.form.worksNum) >500 && !arrMsg) {
                arrMsg = '作品集数不能大于500集';
            }else if (!arrMsg && this.form.worksNum && !checkNum(this.form.worksNum)) {
                arrMsg = '作品集数必须是数字';
            } else {
                submitReqBody.worksNum = this.form.worksNum;
            }
            
            if (arrMsg) {
                this.$alert(arrMsg);
            } else {
                this.dialogFormVisible = true;
                this.submitReqBody = submitReqBody;
            }
        },
        submit_form: function() {
            console.log('submitReqBody', this.submitReqBody);
            if (this.submitReqBody) {
                if (!checkMobile(this.form.verifyPhone)) {
                    this.$alert('请填写正确的验证手机');
                    return;
                } else {
                    this.submitReqBody.joiner_verify_phone = this.form.verifyPhone;
                }
                if (!this.form.verifyCode) {
                    this.$alert('请填写验证码');
                    return;
                } else {
                    this.submitReqBody.verify_phone_code = this.form.verifyCode;
                }

                signIn(this.submitReqBody)
                    .then((res) => {
                        if (res.code == 0) {
                            this.applicationCode = res.data.application_code;
                            this.dialogFormVisible = false;
                            this.signResultDialogVisible = true;
                        } else if (res.message){
                            this.$alert(res.message);
                        }
                    })
                    .catch();
            }
        },
        backToPrev: function() {
            window.location.replace('//www.ajmide.com/home/contact.html');
        },
        checkNumber:function(e){
            if(!checkNum(e.target.value)){
                e.target.value=''    
            }
        }
    },
};
</script>
